import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { Col, Input, Row, Switch, Tooltip, Button } from "antd";
import { getOrgMessage, setOrgMessage } from "api/proxy/auth-api";
import { useState, useEffect } from "react";
import { getSessionUid } from "utils/utils";

const { TextArea } = Input;

// import Styles from "./styles/settings.module.scss";
const Settings = () => {
  const [isBackupEnabled, setIsBackupEnabled] = useState(false);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const sessionId = null;

  useEffect(() => {
    getOrgMessage((resp) => {
      console.log("Organization message fetched", resp);
      if (resp?.message) setMessage(resp.message);
      setLoading(false);
    });
  }, []);

  const handleToggle = (checked) => {
    setIsBackupEnabled(checked);
    // Add logic to start or stop backup based on the toggle state
  };

  const handleSubmit = async () => {
    if (saving) return;
    setSaving(true);

    setOrgMessage({ message }, () => {
      console.log("Organization message updated" + message);
      setSaving(false);
    });
  };

  if (loading) return null;

  return (
    <div style={{ padding: 24 }}>
      <Row align="middle" gutter={16}>
        <Col>
          <label style={{ fontWeight: 500 }}>Enable Automatic Backup</label>
        </Col>
        <Col>
          <Switch
            checked={isBackupEnabled}
            onChange={handleToggle}
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
          />
        </Col>
      </Row>
      <br />
      <Row>
        <Col>
          <label style={{ fontWeight: 500 }}>Organization login message</label>
        </Col>
        {/* <Col></Col> */}
        <div style={{ display: "flex", flexDirection: "column", gap: 12, width: "100%" }}>
          <TextArea
            disabled={saving}
            style={{ width: "100%" }}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            rows={5}
            placeholder="Set organization-wide message here..."
          />

          <Button
            type="primary"
            onClick={handleSubmit}
            loading={saving}
            style={{ alignSelf: "flex-start" }}
          >
            Save
          </Button>
        </div>
      </Row>
    </div>
  );
};

export default Settings;
